import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { Briefcase } from "lucide-react";
import OccupationLink from "@/components/shared/OccupationLink";

interface RelatedOccupationsProps {
  currentOccupation: {
    title: string;
    soc: string;
    slug: string;
  };
  currentLocation?: string;
  relatedOccupations?: Array<{
    title: string;
    soc: string;
    slug: string;
  }>;
  maxLinks?: number;
}

/**
 * Links to similar/related occupations for SEO internal linking
 */
export default function RelatedOccupations({
  currentOccupation,
  currentLocation = 'united-states',
  relatedOccupations = [],
  maxLinks = 5
}: RelatedOccupationsProps) {
  // If no related occupations provided, generate some based on SOC code similarity
  // (same major group)
  const socMajorGroup = currentOccupation.soc?.split('-')[0];
  
  // For now, show a simple list - in production, this would query the database
  // for occupations with similar SOC codes or use the career recommendations API
  if (relatedOccupations.length === 0) {
    return null; // Don't show if no related occupations
  }

  const displayOccupations = relatedOccupations.slice(0, maxLinks);

  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Briefcase className="h-5 w-5" />
          Related Occupations
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground mb-4">
          Explore similar occupations and career paths:
        </p>
        <ul className="space-y-2">
          {displayOccupations.map((occ) => (
            <li key={occ.soc}>
              <OccupationLink
                occupation={occ}
                location={currentLocation}
                className="text-primary hover:underline"
              >
                {occ.title}
              </OccupationLink>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
}

